import React from 'react';
import { useState } from 'react';
import { Button } from 'react-bootstrap';

import { useEffect } from 'react';
import Uuid from '../../../../../support/Uuid';
import AportacionesODepositosForm from './AportacionesODepositosForm';
import AportacionesODepositosList from './AportacionesODepositosList';

const Manager = (props) => {
  const [data, setData] = useState([]);
  const [editing, setEditing] = useState({});
  const [showForm, setShowForm] = useState(true);

  const { data: complemento } = props;

  useEffect(() => {
    setData([]);
  }, [complemento]);

  const handleOnAdd = (value) => {
    const { TipoAportacionODeposito } = value;

    let TipoAportacionODepositoLabel = '';

    if (TipoAportacionODeposito === 'a') {
      TipoAportacionODepositoLabel = 'Aportaciones voluntarias o complementarias efectuadas en términos del artículo 151, fracción V de la LISR. (a)'
    }

    if (TipoAportacionODeposito === 'b') {
      TipoAportacionODepositoLabel = 'Depósitos a cuentas especiales, prima de seguros o adquisición de acciones, efectuadas en términos al artículo 185 de la LISR (b)'
    }

    if (TipoAportacionODeposito === 'c') {
      TipoAportacionODepositoLabel = 'Aportaciones adicionales efectuadas en términos del artículo 258 (c)'
    }

    const newState = [].concat(data, [{
      id: Uuid.v4(),
      ...value,
      TipoAportacionODepositoLabel: TipoAportacionODepositoLabel,
    }]);

    const AportacionesODepositos = newState;

    props.onAportacionesODepositosAdd({ AportacionesODepositos });

    setData(newState);
    setShowForm(false);
  };

  const handleOnEdit = (item) => {
    setEditing(item);
    setShowForm(true);

    setData(data.filter((value) => value.id !== item.id));

    setTimeout(() => {
      setEditing({});
    }, 500);
  }

  const handleOnClick = (event) => {
    setShowForm(!showForm);
  };

  const handleOnListChange = (data) => {
    setData(data);
  }

  return (
    <>
      { !showForm && (
        <div className="py-2 mr-3">
          <p>¿Quieres agregar un nuevo tipo de aportación o depósito que realiza el aportante a su plan de retiro ?</p>

          <Button
            variant="secondary"
            onClick={ handleOnClick }
          >
            Nuevo Depósito o Aportación
          </Button>

        </div>
      )}

      { !!showForm && (
        <AportacionesODepositosForm
          data={ editing }
          onAdd={ handleOnAdd }
        />
      )}

      <AportacionesODepositosList
        onListChange={ handleOnListChange }
        onEdit={ handleOnEdit }
        data={ data }
      />
    </>
  );
};

export default Manager;
